import React from "react";
import { Link } from "react-router-dom";

import Toast from "../../Utils/Toast";

import "../../Styles/Button.css";

const Button = ({
  text,
  link,
  shadowType,
  mobilePosition,
  disabled,
  prevPath,
  toastText,
  fontSize,
  heightSize,
  id,
  customClass,
}) => {
  const showToast = () => {
    if (toastText.length > 0) {
      Toast(toastText[0], toastText[1]);
    }
  };

  return (
    <>
      {disabled ? (
        <div
          id={id || ""}
          className={`
             Button_wrapper 
             ${shadowType == "inset" ? "inset-box-shadow " : ""}
             ${mobilePosition == "right" ? "mobile-right " : ""}
             disabled
             ${customClass || ""}
         `}
          style={
            heightSize
              ? { lineHeight: heightSize, alignItems: "flex-start" }
              : { alignItems: "flex-start" }
          }
        >
          <svg
            className="d-mob-none"
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="14"
            viewBox="0 0 19 14"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.7429 7.11876C18.7429 6.93446 18.6753 6.75771 18.555 6.62739C18.4348 6.49707 18.2716 6.42386 18.1015 6.42386H2.9723L7.00957 2.05154C7.06921 1.98693 7.11652 1.91023 7.14879 1.82581C7.18107 1.7414 7.19768 1.65092 7.19768 1.55955C7.19768 1.46818 7.18107 1.3777 7.14879 1.29329C7.11652 1.20887 7.06921 1.13217 7.00957 1.06756C6.94993 1.00295 6.87913 0.951699 6.8012 0.916733C6.72328 0.881766 6.63977 0.86377 6.55542 0.86377C6.47108 0.86377 6.38756 0.881766 6.30964 0.916733C6.23172 0.951699 6.16092 1.00295 6.10128 1.06756L0.969699 6.62677C0.909964 6.69132 0.86257 6.768 0.830233 6.85243C0.797895 6.93685 0.78125 7.02736 0.78125 7.11876C0.78125 7.21016 0.797895 7.30067 0.830233 7.38509C0.86257 7.46952 0.909964 7.5462 0.969699 7.61075L6.10128 13.17C6.16092 13.2346 6.23172 13.2858 6.30964 13.3208C6.38756 13.3558 6.47108 13.3737 6.55542 13.3737C6.63977 13.3737 6.72328 13.3558 6.8012 13.3208C6.87913 13.2858 6.94993 13.2346 7.00957 13.17C7.06921 13.1054 7.11652 13.0286 7.14879 12.9442C7.18107 12.8598 7.19768 12.7693 7.19768 12.678C7.19768 12.5866 7.18107 12.4961 7.14879 12.4117C7.11652 12.3273 7.06921 12.2506 7.00957 12.186L2.9723 7.81366H18.1015C18.2716 7.81366 18.4348 7.74045 18.555 7.61013C18.6753 7.47981 18.7429 7.30306 18.7429 7.11876Z"
              fill="#020D1B"
            />
          </svg>
          <span>{text}</span>
        </div>
      ) : (
        <Link
          id={id || ""}
          to={link}
          state={{ prevPath: prevPath }}
          className={`
                Button_wrapper
                ${shadowType == "inset" ? "inset-box-shadow" : ""}
                ${mobilePosition == "right" ? "mobile-right" : ""}
                ${customClass || ""}
            `}
          onClick={showToast}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="14"
            viewBox="0 0 19 14"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.7429 7.11876C18.7429 6.93446 18.6753 6.75771 18.555 6.62739C18.4348 6.49707 18.2716 6.42386 18.1015 6.42386H2.9723L7.00957 2.05154C7.06921 1.98693 7.11652 1.91023 7.14879 1.82581C7.18107 1.7414 7.19768 1.65092 7.19768 1.55955C7.19768 1.46818 7.18107 1.3777 7.14879 1.29329C7.11652 1.20887 7.06921 1.13217 7.00957 1.06756C6.94993 1.00295 6.87913 0.951699 6.8012 0.916733C6.72328 0.881766 6.63977 0.86377 6.55542 0.86377C6.47108 0.86377 6.38756 0.881766 6.30964 0.916733C6.23172 0.951699 6.16092 1.00295 6.10128 1.06756L0.969699 6.62677C0.909964 6.69132 0.86257 6.768 0.830233 6.85243C0.797895 6.93685 0.78125 7.02736 0.78125 7.11876C0.78125 7.21016 0.797895 7.30067 0.830233 7.38509C0.86257 7.46952 0.909964 7.5462 0.969699 7.61075L6.10128 13.17C6.16092 13.2346 6.23172 13.2858 6.30964 13.3208C6.38756 13.3558 6.47108 13.3737 6.55542 13.3737C6.63977 13.3737 6.72328 13.3558 6.8012 13.3208C6.87913 13.2858 6.94993 13.2346 7.00957 13.17C7.06921 13.1054 7.11652 13.0286 7.14879 12.9442C7.18107 12.8598 7.19768 12.7693 7.19768 12.678C7.19768 12.5866 7.18107 12.4961 7.14879 12.4117C7.11652 12.3273 7.06921 12.2506 7.00957 12.186L2.9723 7.81366H18.1015C18.2716 7.81366 18.4348 7.74045 18.555 7.61013C18.6753 7.47981 18.7429 7.30306 18.7429 7.11876Z"
              fill="#020D1B"
            />
          </svg>
          <span style={fontSize ? { fontSize, padding: heightSize } : null}>
            {text}
          </span>
        </Link>
      )}
    </>
  );
};

Button.defaultProps = {
  link: "#",
  disabled: false,
  shadowType: "outset",
  mobilePosition: "center",
  prevPath: "#",
  toastText: [],
};

export default Button;
